import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanelLeftCloseFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.745 12.405a1 1 0 1 1 1.414 1.412l-2.26 2.263 2.306 2.308a1 1 0 1 1-1.413 1.414l-3.016-3.015a1 1 0 0 1 0-1.414z" />
    <path
      fillRule="evenodd"
      d="M26.499 2.002c1.857-.067 3.423 1.275 3.5 3V28c-.08 1.073-1 1.927-2.155 2H4.156C3 29.927 2.08 29.073 2.002 28V5.002c.076-1.725 1.642-3.067 3.5-3zm0 2H12.982V28h14.862V5.002c-.09-.613-.681-1.053-1.345-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanelLeftCloseFilledSVG);
ForwardRef.displayName = "IconPanelLeftCloseFilled";
export { ForwardRef as IconPanelLeftCloseFilled };
